export default __webpack_public_path__ + "static/media/twoscreen.856f7ba5.png";